/* HEADER SCRIPTS */


// Toggle menu 

const toggle = document.getElementById("menu-toggle");
const nav_items = document.getElementById("nav_items");

toggle.addEventListener("click", () => {
    nav_items.classList.toggle("active");
    toggle.classList.toggle("open");
});


